<template>
    <DropdownButton>
        <template v-slot:trigger>
            <button class="button">
                <span>{{ translate("notification_center.payments_filter") }}</span>
                <span class="icon">
                    <i class="fa fa-caret-down" />
                </span>
            </button>
        </template>
        <template v-slot:content>
            <a class="dropdown-item" @click="choosePaymentStatus(NONE)">
                <span class="icon">
                    <i :class="getPaymentStatusClass(NONE)" />
                </span>
                <span>{{ translate("notification_center.payments_filter.choose_all") }}</span>
            </a>
            <a class="dropdown-item has-text-success" @click="choosePaymentStatus(AT_LEAST_ONE_COMPLETE)">
                <span class="icon"> <i :class="getPaymentStatusClass(AT_LEAST_ONE_COMPLETE)" /> </span>
                <span>{{ translate("notification_center.payments_filter.at_least_one_complete") }}</span>
            </a>
            <a class="dropdown-item has-text-danger" @click="choosePaymentStatus(AT_LEAST_ONE_MISSING)">
                <span class="icon"> <i :class="getPaymentStatusClass(AT_LEAST_ONE_MISSING)" /> </span>
                <span>{{ translate("notification_center.payments_filter.at_least_one_missing") }}</span>
            </a>
        </template>
    </DropdownButton>
</template>

<script>
    import DropdownButton from "../../Common/DropdownButton";
    import { mapState } from "vuex";
    import translatorMixin from "../../Common/translatorMixin";
    import { PAYMENT_AT_LEAST_ONE_COMPLETE, PAYMENT_AT_LEAST_ONE_MISSING, PAYMENT_NONE } from "../createNotification";

    export default {
        name: "payment-status-filter",
        components: {
            DropdownButton,
        },
        mixins: [translatorMixin],
        computed: {
            ...mapState("filteringReceivers", ["paymentStatus"]),
        },
        created() {
            this.NONE = PAYMENT_NONE;
            this.AT_LEAST_ONE_COMPLETE = PAYMENT_AT_LEAST_ONE_COMPLETE;
            this.AT_LEAST_ONE_MISSING = PAYMENT_AT_LEAST_ONE_MISSING;
        },
        methods: {
            getPaymentStatusClass(paymentStatus) {
                return this.paymentStatus === paymentStatus ? "fa fa-check-circle" : "far fa-circle";
            },
            choosePaymentStatus(paymentStatus) {
                this.$store.commit("filteringReceivers/setPaymentStatus", paymentStatus);
                this.$store.dispatch("filteringReceivers/getSearchSummary");
            },
        },
    };
</script>

<style scoped></style>
